import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AxiosError } from 'axios';

import { store } from '@/Infrastructure/State';
import type { TErrorResponse } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';

import type {
  shippingMethodBodyRequest,
  ShippingMethodRepository
} from '../../domain/ShippingMethodRepository';
import type { HttpShippingMethodResponse } from '../dto/HttpShippingMethodDto';
import { getGeneralShippingMethods } from '../services/queries/getGeneralShippingMethods';

const FETCH_GENERAL_SHIPPING_METHODS = 'shippingMethods';

export const getShippingMethods = createAsyncThunk(
  FETCH_GENERAL_SHIPPING_METHODS,
  async (
    { params }: { params?: shippingMethodBodyRequest[] },
    { rejectWithValue }
  ) => {
    try {
      const response = await getGeneralShippingMethods(params);

      return response.data;
    } catch (error) {
      const errorInfo = (error as AxiosError)?.response?.data as TErrorResponse;

      return rejectWithValue(errorInfo);
    }
  }
);

const ShippingMethodsReduxRepository: ShippingMethodRepository = {
  getGeneralShippingMethods: async (params?: shippingMethodBodyRequest[]) => {
    const { payload } = await store.dispatch(getShippingMethods({ params }));
    return payload as HttpShippingMethodResponse;
  }
};
export default ShippingMethodsReduxRepository;
